import { render, staticRenderFns } from "./baseSelect.vue?vue&type=template&id=e8bebae8&scoped=true&"
import script from "./baseSelect.vue?vue&type=script&lang=ts&"
export * from "./baseSelect.vue?vue&type=script&lang=ts&"
import style0 from "./baseSelect.vue?vue&type=style&index=0&id=e8bebae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bebae8",
  null
  
)

export default component.exports